// Request
import { doRequest } from '@/utils/requestApi'

/**
 * Obtenemos las compañías "brandeadas" por otra compañía
 *
 * @param {String} brandId - Id de compañía (patrocinadora)
 */
export async function getCompaniesByBrandId(brandId) {
  const result = await doRequest({
    method: 'get',
    url: `v1/brand/companies/${brandId}`
  })

  return result.data
}

/**
 * Obtenemos los establecimientos "patrocinados" por la compañía asociada
 *
 * @param {String} brandId - Id de compañía (patrocinadora)
 */
export async function getManagedPlacesByBrandId(brandId) {
  const result = await doRequest({
    method: 'get',
    url: `v1/brand/places/${brandId}`
  })

  return result.data
}
